import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../components/Header/Header.css";
import { useTranslation } from "react-i18next";
import { SocialIcon } from "react-social-icons";
import { FaViber } from "react-icons/fa";

function OverlayMenu() {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  return (
    <React.Fragment>
      <div className={`offcanvas-menu-overlay ${isOpen ? "active" : ""}`}></div>
      <div onClick={toggleSidebar} className="canvas-open">
        <i className="icon_menu"></i>
      </div>
      <div
        className={`offcanvas-menu-wrapper ${
          isOpen ? "show-offcanvas-menu-wrapper" : ""
        }`}
      >
        <div className="canvas-close" onClick={closeSidebar}>
          <i className="icon_close"></i>
        </div>
        <div className="header-configure-area">
          <div className="language-option">
            <img src={`./icons/${language}.png`} alt="" />
            <span>
              {language.toUpperCase()} <i className="fa fa-angle-down"></i>
            </span>
            <div className="flag-dropdown">
              <ul>
                <li>
                  <button
                    style={{
                      borderStyle: "none",
                      backgroundColor: "transparent",
                    }}
                    onClick={() =>
                      changeLanguage(language === "en" ? "gr" : "en")
                    }
                  >
                    {language === "en" ? "GR" : "EN"}
                    <span className="spanLanguage"></span>
                    <img
                      src={`./icons/${language === "en" ? "gr" : "en"}.png`}
                      alt=""
                    />
                  </button>
                </li>
              </ul>
            </div>
          </div>
          {/* <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.booking.com/hotel/gr/rafkon-myrina-apartments.el.html"
            className="bk-btn"
          >
            {t("header.booking")}
          </a> */}
        </div>
        <nav className="slicknav_menu">
          <ul>
            <li>
              <Link to="/">{t("header.home")}</Link>
            </li>
            <li>
              <Link to="/about">{t("header.about")}</Link>
            </li>
            <li>
              <Link to="/rooms">{t("header.rooms")}</Link>
            </li>
            <li>
              <Link to="/gallery">{t("header.gallery")}</Link>
            </li>
            <li>
              <Link to="/contact">{t("header.contact")}</Link>
            </li>
          </ul>
        </nav>
        <div className="top-social">
          <SocialIcon
            target="_blank"
            rel="noopener noreferrer"
            url="https://www.facebook.com/rafkonapartmentslxs/"
            style={{ height: 30, width: 30 }}
          />
          <SocialIcon
            target="_blank"
            rel="noopener noreferrer"
            url="https://www.instagram.com/rafkon_apartments/"
            style={{ height: 30, width: 30 }}
          />
          <SocialIcon
            url="https://wa.me/306981583591"
            style={{ height: 30, width: 30 }}
          />
          <a
            href="viber://chat?number=306981583591"
            style={{
              height: 30,
              width: 30,
              borderRadius: "50%",
              background: "#7360F2",
            }}
          >
            <FaViber size={14} color="white" />
          </a>
        </div>
        <ul id="info-overlay" className="top-widget">
          <li>
            <i className="fa fa-phone"></i>
            <a href="tel:+302254026424">+30 2254026424</a>
          </li>
          <li>
            <i className="fa fa-envelope"></i>
            <a href="mailto:rafkonoe@gmail.com">rafkonoe@gmail.com</a>
          </li>
          <li style={{marginTop:"50px"}}>
            <a
              href="https://g.page/r/CVeeXJ1IN283EBM/review"
              target="_blank"
              rel="noopener noreferrer"
              className="bk-btn"
            >
              <img style={{width:"200px"}} src="./img/3.png" alt="Review us on Google" />
            </a>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
}

export default OverlayMenu;
